<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useWebSiteStore } from '@/stores/web-site.store'
import { useRegistryStore } from '@/stores/registry.store'

import AvatarTemplate from '@/components/shared/AvatarTemplate.vue'

const props = defineProps({
  currentUser: {
    type: Boolean,
    default: false
  },
  entityName: {
    type: String,
    default: null
  },
  entityId: {
    type: Number,
    default: null
  },
  size: {
    type: String,
    default: '72px'
  }
})

const webSiteStore = useWebSiteStore()
const registryStore = useRegistryStore()

const getUnlockAtByEntityId = (entityName, entityId) => {
  return webSiteStore.entityLocks[`${entityName}.${entityId}`]?.unlock_at
}

const unlockAt = computed(() => {
  const val = getUnlockAtByEntityId(props.entityName, props.entityId)
  return val ? new Date(val) : null
})

const totalSeconds = registryStore.companyData.entity_lock_duration_minutes * 60
const remainingSeconds = ref(totalSeconds)
let intervalId = null

onMounted(() => {
  intervalId = setInterval(() => {
    if (unlockAt.value) {
      const diffMs = unlockAt.value - new Date()
      remainingSeconds.value = Math.max(0, Math.floor(diffMs / 1000))
    } else {
      remainingSeconds.value = 0
    }
  }, 1000)
})

onBeforeUnmount(() => {
  if (intervalId) clearInterval(intervalId)
})

const progressValue = computed(() => {
  return Math.min(((totalSeconds - remainingSeconds.value) / totalSeconds) * 100, 100)
})

const qCircularProgressSize = computed(() => {
  const sizeStr = props.size.slice(0, -2)
  const sizeNum = parseInt(sizeStr, 10)
  if (!isNaN(sizeNum)) {
    return `${sizeNum + 4}px`
  }
  return '76px'
})

</script>

<template>
  <div>
    <div
      v-if="props.currentUser || !getUnlockAtByEntityId(props.entityName, props.entityId)"
    >
      <avatar-template
        :current-user="props.currentUser"
        :entity-name="props.entityName"
        :entity-id="props.entityId"
        :size="props.size"
      />
    </div>
    <div
      v-else
    >
      <q-circular-progress
        show-value
        :value="progressValue"
        color="white"
        track-color="primary"
        :size="qCircularProgressSize"
        reverse
      >
        <avatar-template
          :current-user="props.currentUser"
          :entity-name="props.entityName"
          :entity-id="props.entityId"
          :suffix-tooltip="`${remainingSeconds.toFixed(0)}`"
          :size="props.size"
        />
      </q-circular-progress>
    </div>
  </div>
</template>

<style scoped>
</style>
